<template>
  <div class="home">
    <div class="flex-column-1">
      <mt-loadmore :top-method="loadTop" ref="loadmore" style="min-height: 100%;">
        <div class="search">
          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center">
              <span>
                <img src="@/assets/imgs/icons/position.png" alt />
              </span>
              <strong @click="pickAddress('change')" class="city">&nbsp;{{ localCity }}</strong>
            </div>
            <div class="search-box flex-fill d-flex align-items-center ">
              <input
                type="serch"
                ref="inputClose"
                @focus="searchFoucs"
                @blur="searchBlur"
                @keypress="searchLine"
                v-model="seachKey"
                placeholder="请输入目的地或公司简称"
              />
              <i class="fa fa-search" @click="search"></i>
            </div>
          </div>
        </div>
        <section class="section">
          <mt-swipe :auto="4000" style="height:4rem">
            <template v-if="useCompany == 'linanzxcc'">
              <mt-swipe-item><img class="img-fluid" src="@/assets/imgs/home/linanbanner1.jpg" alt/></mt-swipe-item>
              <mt-swipe-item><img class="img-fluid" src="@/assets/imgs/home/linanbanner2.jpg" alt/></mt-swipe-item>
              <mt-swipe-item><img class="img-fluid" src="@/assets/imgs/home/linanbanner3.jpg" alt/></mt-swipe-item>
            </template>
            <template v-else-if="bannerList.length">
              <mt-swipe-item v-for="(item, index) in bannerList" :key="index">
                <img class="img-fluid" :src="item.bannerUrl" alt />
              </mt-swipe-item>
            </template>
            <img class="img-fluid" v-else @click="oilRechare" src="@/assets/imgs/home/home-banner1.png" alt />
          </mt-swipe>
          <!--<div class="banner">
		        <img class="img-fluid" src="@/assets/imgs/dynamic/notice_0.png" alt>
		      </div>-->
          <div class="d-flex justify-content-between align-items-center select-addres">
            <div @click="pickAddress('start')">
              <span class="select-down clearfix start">
                始发地
                <i class="fa fa-caret-down"></i>
              </span>
              <!--<h4 v-if="!start">全部</h4>-->
              <h4>{{ start }}</h4>
            </div>
            <div class="img-box-m">
              <img src="@/assets/imgs/icons/car.png" alt />
            </div>
            <div @click="pickAddress('end')">
              <span class="select-down clearfix end">
                目的地
                <i class="fa fa-caret-down"></i>
              </span>
              <!--<h4 v-if="!end">全部</h4>-->
              <h4>{{ end }}</h4>
            </div>
          </div>
          <div class="addres">
            <div class="historical-records">
              <ul class="d-flex item-list">
                <li class="item" v-for="(item, index) in searchHistory" :key="index">
                  <i class="fa fa-clock-o"></i>&nbsp;<span v-if="item.startCityName">{{ item.startCityName }}</span
                  ><span v-else>全部</span>-<span v-if="item.destCityName">{{ item.destCityName }}</span
                  ><span v-else>全部</span>
                </li>
              </ul>
            </div>
            <div class="voice">
              <div class="record-vioce" v-if="isRecord">
                <div class="example">试试这样说</div>
                <div class="adress-voice">“广州到北京”&nbsp;&nbsp; 或 &nbsp;&nbsp;“北京”</div>
                <img src="@/assets/imgs/home/voice_1.png" :class="{ touchimg: isRecord }" alt="" />
                <div class="example">手指上滑，取消搜索</div>
              </div>
              <button
                @touchstart="vioceStart"
                @touchmove="cancelVioce"
                @touchend="vioceEnd"
                class="search-btn"
                type="primary"
              >
                语音查询
              </button>
            </div>
          </div>
          <div class="product-links">
            <ul class="item-ul">
              <template v-for="(production, index) in productionLists">
                <li
                  v-if="
                    (!specialList && !production.belongTo) || (specialList && specialList.includes(production.text))
                  "
                  class="item-li"
                  :key="index"
                >
                  <font class="" @click="goTo(production)">
                    <div class="img-box">
                      <img :src="require(`@/assets/imgs/icons/${production.icon}`)" alt />
                    </div>
                    <span class="text-center">{{ production.text }}</span>
                  </font>
                </li>
              </template>
              <template v-for="(production, index) in logisticIndexConfigList">
                <li class="item-li">
                  <font class="" @click="toUrl(production.url)">
                    <div class="img-box">
                      <img :src="production.iconUrl" alt />
                    </div>
                    <span class="text-center">{{ production.title }}</span>
                  </font>
                </li>
              </template>
            </ul>
            <!--<SettledIn/>-->
          </div>
        </section>
        <div slot="top" class="mint-loadmore-top">
          <img style="height:65px;width:100%" src="../../assets/imgs/home/otmsLoading.gif" alt="" />
        </div>
      </mt-loadmore>
    </div>
    <cityPick @emitCity="emitCity" chooseArea="true" @closePick="showPickCity = false" v-if="showPickCity"></cityPick>
    <footer class="clearfix">
      <NavbarFooter :useCompany_props="useCompany" />
    </footer>
    <mapApp v-if="hasMap"></mapApp>
  </div>
</template>

<script>
import { ROOT_REQUEST } from "@/assets/configs";
import { GET_LOCATION_BY_CITY_CODE, GET_LOGISTIC_PARKS,LOGISTIC_INDEX_CONFIG_LIST } from "@/assets/configs/api/yuanqu";
import { GET_SEARCH_HISTORY } from "@/assets/configs/api/otmsApi";
import axios from "axios";
import { Toast, Swipe, SwipeItem, Loadmore } from "mint-ui";
export default {
  name: "Home",
  data() {
    return {
      bannerList: [],
      appType: "", //app归属
      addres: {},
      seachKey: null,
      showFooter: false,
      start: "全部",
      end: "全部",
      direction: null,
      showPickCity: false,
      localCity: null,
      isRecord: false,
      pageY: 0,
      localPosition: null,
      companyTel: "400-0318-822",
      searchHistory: [],
      logisticIndexConfigList:{},
      useCompany: null
    };
  },
  watch: {},
  computed: {
    hasMap() {
      return this.$store.state.hasMap;
    },
    specialList() {
      if (this.appType == "ywglg") {
        return ["积分活动", "实名认证", "一键导航", "联系我们"];
      } else {
        return false;
      }
    },
    productionLists() {
      let lists = [
        {
          icon: "authentication.png",
          text: "实名认证",
          login: false,
          link: "http://wx.1556.com.cn/#/application",
          belongTo: "ywglg"
        },
        {
          icon: "yuanquzhaoshang.png",
          text: "园区招商",
          login: true,
          link: ROOT_REQUEST.web_base + "h5/parkmall/#/merchant"
        },
        {
          icon: "copy 3@2x.png",
          text: "智慧停车",
          login: true,
          link: ROOT_REQUEST.web_base + "h5/parkingFee/#/assistantParking"
        },
        {
          icon: "level.png",
          text: "一卡通管理",
          login: true,
          link: ROOT_REQUEST.web_base + "h5/parkmall/#/newMemberLevel"
        },
        {
          icon: "qixiuchang.png",
          text: "汽修厂",
          login: true,
          link: ROOT_REQUEST.web_base + "h5/parkmall/#/garage"
        },
        {
          icon: "integral.png",
          text: "积分活动",
          link: "http://wx.1556.com.cn/#/integral/index"
        },
        {
          icon: "etc.png",
          text: "ETC申请",
          login: true,
          link: ROOT_REQUEST.web_base + "h5/shipper_merge/class/banche/myinfo/applicationetc/etcProfile.html"
        },
        {
          icon: "etc-cz.png",
          text: "特惠加油",
          login: true,
          link: ROOT_REQUEST.web_base + "h5/parkmall/#/adverPage"
        },
        {
          icon: "yk.png",
          text: "油卡充值",
          login: true,
          link: ROOT_REQUEST.web_base + "h5/petroleumCard/index.html"
        },
        {
          icon: "shopyk.png",
          text: "购买油卡",
          login: true,
          link: ROOT_REQUEST.web_base + "h5/petroleumCard/index.html",
          params: "isbuyOilCard"
        },
        {
          icon: "yqjf.png",
          text: "园区缴费",
          login: true,
          link: ROOT_REQUEST.web_base + "h5/parkmall/#/propertyPay"
        },
        {
          icon: "wlbx.png",
          text: "物流保险",
          login: false,
          link: ROOT_REQUEST.web_base + "h5/app/banche/buySafe/index.html"
        },
        {
          icon: "dh.png",
          text: "一键导航",
          login: false,
          link: "map"
        },
        {
          icon: "lxwm.png",
          text: "联系我们",
          login: false,
          link: "contact"
        }
      ];
      return lists;
    }
  },
  methods: {
    getBanner() {
      this.$post(
        `${ROOT_REQUEST.messageURL}report/selectScBannerList`,
        {
          logisticsParkCode: sessionStorage.getItem("parkCode")
        },
        res => {
          this.bannerList = res;
        }
      );
    },
    searchFoucs() {},
    searchBlur() {},
    getLogisticParks() {
      this.$get(
        GET_LOGISTIC_PARKS,
        {
          parkCode: sessionStorage.getItem("parkCode")
        },
        data => {
          this.nowParkInfo = data[0];
          this.localPosition = data[0].addr;
          this.start = data[0].areaName || data[0].city
          if('1631' != sessionStorage.getItem("parkCode")){
  	        this.startCity = data[0].city;
        	  this.startArea = data[0].areaName;
          }
          if(data[0].areaName){
            this.startLevel = "area"
          }else if(data[0].city){
            this.startLevel = "city"
          }
        },
        error => {
          Toast(error);
        }
      );
    },
    getHistory() {
      this.$get(
        GET_SEARCH_HISTORY,
        {
          identity: sessionStorage.getItem("useCompany"),
          appUserId: localStorage.getItem("customerId")
        },
        data => {
          this.searchHistory = data;
        },
        error => {
          Toast(error);
        }
      );
    },
    vioceStart(event) {
      this.pageY = event.pageY;
      var isWx = this.isWeiXin();
      if (isWx) {
        this.isRecord = true;
        console.log("start record");
        wx.startRecord();
      } else {
        this.search();
      }
    },
    cancelVioce(event) {
      if (event.pageY - this.pageY < -12) {
        this.isRecord = false;
      }
    },
    vioceEnd() {
      let vm = this;
      if (vm.isRecord == true) {
        setTimeout(() => {
          vm.isRecord = false;
          wx.stopRecord({
            success: function(res) {
              if (res.localId) {
                vm.vioceTransfer(res.localId);
              } else {
                Toast("无法查询结果");
              }
            },
            fail: err => {
              Toast(err);
            },
            failed: err => {
              Toast(err);
            }
          });
        }, 600);
      } else {
        wx.stopRecord({
          success: function(res) {}
        });
      }
    },
    vioceTransfer(localId) {
      let vm = this;
      wx.translateVoice({
        localId: localId, // 需要识别的音频的本地Id，由录音相关接口获得
        isShowProgressTips: 1, // 默认为1，显示进度提示
        success: function(res) {
          // 语音识别的结果
          let length = res.translateResult.length;
          let translateResult = res.translateResult.substring(0, length - 1);
          if (translateResult.indexOf("到") > 1) {
            let arr = translateResult.split("到");
            vm.$router.push({ name: "company-list", query: { start: arr[0], end: arr[1], seachKey: vm.seachKey,startLevel: vm.startLevel,
                endLevel: vm.endLevel} });
          } else {
            vm.$router.push({
              name: "company-list",
              query: { start: vm.start, end: translateResult, seachKey: vm.seachKey,startLevel: vm.startLevel,
                endLevel: vm.endLevel }
            });
          }
        }
      });
    },
    loadTop() {
      setTimeout(() => {
        this.$refs.loadmore.onTopLoaded();
      }, 1000);
    },
    searchLine(event) {
      if (event.keyCode == 13) {
        this.$refs.inputClose.blur();
        event.preventDefault();
        this.search();
      }
    },
    /*导航规划*/
    toMap() {
      if (this.nowParkInfo.lat && this.nowParkInfo.lon) {
        this.showMap({
          lat: this.nowParkInfo.lat,
          lng: this.nowParkInfo.lon
        });
      } else {
        /*获取当前位置*/
        var map, geocoder, marker;
        map = new AMap.Map("container", {
          resizeEnable: true
        });
        var geocoder;
        //加载地理编码插件
        geocoder = new AMap.Geocoder({
          city: "全国"
        });
        geocoder.getLocation(this.nowParkInfo.addr, function(status, result) {
          if (status == "no_data") {
            Toast("地址无法定位");
          }
          if (status === "complete" && result.geocodes.length) {
            var lnglat = result.geocodes[0].location;
            this.showMap(lnglat);
          }
        });
      }
    },
    showMap(lnglat) {
      var isWx = this.isWeiXin();
      if (isWx) {
        wx.openLocation({
          latitude: parseFloat(lnglat.lat),
          longitude: parseFloat(lnglat.lng),
          name: this.nowParkInfo.addr,
          address: this.nowParkInfo.addr,
          scale: 18,
          infoUrl: ROOT_REQUEST.web_base + "h5/specialline/#/home",
          fail: res => {
            alert(JSON.stringify(res));
          }
        });
      } else {
        this.$store.state.parkLng = lnglat.lng;
        this.$store.state.parkLat = lnglat.lat; /*选中园区的纬度*/
        this.$store.state.hasMap = true;
      }
    },
    showCityInfo() {
      let vm = this;
      //实例化城市查询类
      var citysearch = new AMap.Geolocation();
      //自动获取用户IP，返回当前城市
      citysearch.getCurrentPosition(function(status, result) {
        if (status === "complete" && result && result.addressComponent) {
          if (result.addressComponent.district) {
            vm.localCity = result.addressComponent.district;
            sessionStorage.setItem("cityLocalName", result.addressComponent.district);
          } else if (result.addressComponent.city) {
            vm.localCity = result.addressComponent.city;
            sessionStorage.setItem("cityLocalName", result.addressComponent.city);
          } else if (result.addressComponent.province) {
            vm.localCity = result.addressComponent.province;
            sessionStorage.setItem("cityLocalName", result.addressComponent.province);
          }
          localStorage.setItem("curLng", result.position.lng);
          localStorage.setItem("curLat", result.position.lat);
        } else {
          console.log("获取本地定位失败：" + result.info);
        }
      });
    },
    emitCity(data) {
      if (this.direction == "start") {
        if (Object.keys(data).length) {
          if (data.areaText && data.areaText != "全市") {
            this.start = data.areaText;
            this.startLevel = "area";
          } else {
            this.start = data.cityText;
            this.startLevel = "city";
          }
        }
        if (this.end == "全部") {
        } else {
          if (Object.keys(data).length && this.start && this.end) {
            this.$router.push({
              name: "company-list",
              query: {
                start: this.start,
                end: this.end,
                startLevel: this.startLevel,
                endLevel: this.endLevel,
                seachKey: this.seachKey
              }
            });
          }
        }
      } else if (this.direction == "end") {
        if (Object.keys(data).length) {
          if (data.areaText && data.areaText != "全市") {
            this.end = data.areaText;
            this.endLevel = "area";
          } else {
            this.end = data.cityText;
            this.endLevel = "city";
          }
        }
        if (Object.keys(data).length && this.start && this.end) {
          this.$router.push({
            name: "company-list",
            query: {
              start: this.start,
              end: this.end,
              startLevel: this.startLevel,
              endLevel: this.endLevel,
              seachKey: this.seachKey
            }
          });
        }
      } else if (this.direction == "change") {
        if (Object.keys(data).length) {
          if (data.areaText && data.areaText != "全市") {
            this.localCity = data.areaText;
          } else {
            this.localCity = data.cityText;
          }
          sessionStorage.setItem("cityLocalName", this.localCity);
          localStorage.setItem("cityCodeSl", null);
          this.getLocal(this.localCity);
          //					this.localPosition = this.localCity
        }
      }
      //组件返回有地址时，而且满足有始发地和目的地时跳转页面，执行搜索

      this.showPickCity = false;
    },
    getLocal(code) {
      this.$get(
        GET_LOCATION_BY_CITY_CODE,
        { cityCode: code },
        data => {
          localStorage.setItem("curLng", data.lon);
          localStorage.setItem("curLat", data.lat);
        },
        error => {
          Toast(error);
        }
      );
    },
    pickAddress(direction) {
      this.direction = direction;
      this.showPickCity = true;
    },
    search() {
      this.$router.push({
        name: "company-list",
        query: {
          start: this.start,
          end: this.end,
          startLevel: this.startLevel,
          endLevel: this.endLevel,
          seachKey: this.seachKey,
          startCity :this.startCity,
          startArea :this.startArea,
        }
      });
    },
    oilRechare() {
      var vm = this;
      let urlParmars = window.localStorage.getItem("userId") ? window.localStorage.getItem("userId").split(" ")[1] : "";
      let account = localStorage.getItem("mobile") || "";
      if (urlParmars) {
        location.href = ROOT_REQUEST.web_base + "h5/petroleumCard/index.html?isbuyOilCard=isbuyOilCard";
      } else {
        if (this.isWeiXin()) {
          wx.miniProgram.getEnv(function(res) {
            if (res.miniprogram) {
              localStorage.setItem("zxRedirction", vm.$route.fullPath);
              wx.miniProgram.navigateTo({
                url: "/pages/wxLogin/wxLogin?redirection="
              });
            }
          });
          setTimeout(function() {
            vm.$router.push({ name: "auth-login", query: { redirect: vm.$route.fullPath } });
          }, 1000);
        } else {
          vm.$router.push({ name: "auth-login", query: { redirect: vm.$route.fullPath } });
        }
      }
    },
    toUrl(url){
    	location.href = url;
    },
    goTo(item) {
      var vm = this;
      let urlParmars = window.localStorage.getItem("userId") ? window.localStorage.getItem("userId").split(" ")[1] : "";
      let account = localStorage.getItem("mobile") || "";
      if (item.login == true) {
        if (urlParmars) {
          if (item.link) {
            localStorage.setItem("origin", "specialline");
            if (item.params == "isbuyOilCard") {
              location.href =
                item.link +
                "?origin=specialline&isbuyOilCard=isbuyOilCard" +
                "&account=" +
                account +
                "&authorization=" +
                urlParmars;
            } else {
              location.href =
                item.link + "?origin=specialline" + "&account=" + account + "&authorization=" + urlParmars;
            }
          }
        } else {
          if (this.isWeiXin()) {
            wx.miniProgram.getEnv(function(res) {
              if (res.miniprogram) {
                localStorage.setItem("zxRedirction", vm.$route.fullPath);
                wx.miniProgram.navigateTo({
                  url: "/pages/wxLogin/wxLogin?redirection="
                });
              }
            });
            setTimeout(function() {
              vm.$router.push({ name: "auth-login", query: { redirect: vm.$route.fullPath } });
            }, 1000);
          } else {
            vm.$router.push({ name: "auth-login", query: { redirect: vm.$route.fullPath } });
          }
        }
      } else {
        if (item.link == "map") {
          //之前是 this.cityLocalName
          if ((this.nowParkInfo.lat && this.nowParkInfo.lon) || this.nowParkInfo.addr) {
            this.toMap();
          } else {
            Toast("暂时无法获取位置");
          }
        } else if (item.link == "contact") {
          window.location.href = "tel://" + this.companyTel;
        } else {
          location.href = item.link + "?origin=specialline" + "&account=" + account + "&authorization=" + urlParmars;
        }
      }
    },
    getJsApiParam() {
      var isWx = this.isWeiXin();
      if (isWx) {
        //微信打开
        var vm = this;
        window.sessionStorage.setItem("noLogin", true);
        //百驿 appid
        let wx_pub_b100y_appid = "wx9c1dcb31c878d8f3";
        this.$get(
          `https://www.wy56.com/truck-api/v002/commentLottoController/getJsApiParamV2?appid=${wx_pub_b100y_appid}&url=${encodeURIComponent(location.href.split("#")[0])}`,
          {},
          data => {
            console.log("获取到配置参数，开始配置微信sdk");
            window.sessionStorage.removeItem("noLogin");
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: data.appId,
              timestamp: data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.signature,
              jsApiList: [
                "getLocation",
                "openLocation",
                "startRecord",
                "stopRecord",
                "onVoiceRecordEnd",
                "translateVoice"
              ]
            });
          },
          error => {
            window.sessionStorage.removeItem("wx");
          }
        );
      }
    },
    getLogisticIndexConfigList(parkCode,type){
      this.$get(
        LOGISTIC_INDEX_CONFIG_LIST,
        { parkCode: parkCode,type:type},
        data => {
        	this.logisticIndexConfigList = data;
        },
        error => {
          Toast(error);
        }
      );    	
    }
  },
  mounted() {
    if (this.$route.query.useCompany) {
      localStorage.setItem("useCompany", this.$route.query.useCompany);
      sessionStorage.setItem("useCompany", this.$route.query.useCompany);
    }
    if (sessionStorage.getItem("useCompany") == "hdzxcc") {
      this.companyTel = "400-0318-822";
      sessionStorage.setItem("parkCode", "1383");
    }
    if (sessionStorage.getItem("useCompany") == "hyzxcc") {
      this.companyTel = "4008836568";
      sessionStorage.setItem("parkCode", "1002");
    }
    if (sessionStorage.getItem("useCompany") == "byzxcc") {
      this.companyTel = "010-58565158";
      sessionStorage.setItem("parkCode", "1000");
    }
    if (sessionStorage.getItem("useCompany") == "linanzxcc") {
      this.companyTel = "010-58565158";
      sessionStorage.setItem("parkCode", "1000");
    }
    if (sessionStorage.getItem("useCompany") == "yingtanwlcc") {
      this.companyTel = "13807019127";
      sessionStorage.setItem("parkCode", "1018");
    }
    //义乌公路港
    if (sessionStorage.getItem("useCompany") == "ywglg") {
      this.appType = "ywglg";
      this.companyTel = "0579-85022561";
      sessionStorage.setItem("parkCode", "1631");
      this.getLogisticIndexConfigList("1631","1");
    }

    this.useCompany = sessionStorage.getItem("useCompany");

    localStorage.removeItem("origin");
    //是否有存储 本地地址
    if (sessionStorage.getItem("cityLocalName")) {
      this.localCity = sessionStorage.getItem("cityLocalName");
    } else {
      //获取本地地址
      this.showCityInfo();
    }

    if (sessionStorage.getItem("parkCode")) {
      this.getLogisticParks();
    }
    this.getJsApiParam();
    if (localStorage.getItem("customerId") && sessionStorage.getItem("useCompany")) {
      this.getHistory();
    }
    if (sessionStorage.getItem("parkCode")) {
      this.getBanner();
    }
  }
};
</script>


<style lang="sass" scoped>
@import "./home";
</style>
